import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
        appBar: {
            backgroundColor: "#2962ff",            
            padding: "1rem",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center"
        },
        marginTop: {
            marginTop: "3rem"
        }
}));